import { create } from "zustand";
import type { CashBalance, CashBalanceKey } from "../types/cash";

interface CashBalanceState {
  balances: Map<CashBalanceKey, CashBalance>;
  setSnapshot: (data: CashBalance[]) => void;
  applyDelta: (upsert: CashBalance[], removed: CashBalanceKey[]) => void;
}

export const useCashBalanceStore = create<CashBalanceState>((set, get) => ({
  balances: new Map(),
  setSnapshot: (data) => {
    const m = new Map<CashBalanceKey, CashBalance>();
    for (const b of data) m.set(`${b.entity_id}:${b.book_id}:${b.currency}` as CashBalanceKey, b);
    set({ balances: m });
  },
  applyDelta: (upsert, removed) => {
    const next = new Map(get().balances);
    for (const k of removed) next.delete(k);
    for (const b of upsert) next.set(`${b.entity_id}:${b.book_id}:${b.currency}` as CashBalanceKey, b);
    set({ balances: next });
  },
}));

export function selectBalancesArray(s: CashBalanceState): CashBalance[] {
  return Array.from(s.balances.values());
}
